export default __webpack_public_path__ + "static/media/3c03a437c1f5e94580d46ce579d659f4.svg";